var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.12,
    height: 33.12,
    viewBox: "0 0 33.12 33.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-search",
    "data-name": "Icon map-search",
    d: "M25.675,21.268a13.1,13.1,0,1,0-4.409,4.406l8.887,8.886,4.407-4.409ZM14.508,22.594a8.08,8.08,0,1,1,8.084-8.076,8.093,8.093,0,0,1-8.084,8.076Z",
    transform: "translate(-1.44 -1.44)",
    fill: "#119a07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.57d4f052c521c8b3fa81368b02f38c54.svg";
export { ForwardRef as ReactComponent };